import * as Sentry from '@sentry/react'

const isProduction = window.location.hostname === 'www.loop11.com'

export default function initSentry() {
  Sentry.init({
    dsn: 'https://a200e543d44f40e78c9050724913e581@o297844.ingest.us.sentry.io/3532007',
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: isProduction ? 0.1 : 1.0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // lazy loading later
    integrations: [],

    tracesSampleRate: isProduction ? 0.1 : 1.0, // Be sure to lower this in production

    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
    // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
    // result in 25% of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate: isProduction ? 0.5 : 1.0,

    environment: isProduction ? 'production' : 'staging',
  })

  // capture the user
  if (window.l11User && window.l11User.email) {
    Sentry.setUser({
      email: window.l11User.email,
      name: window.l11User.name || '',
    })
  }
}

// Lazy Loading Integrations
import('@sentry/react').then((lazyLoadedSentry) => {
  Sentry.addIntegration(lazyLoadedSentry.browserTracingIntegration())
  Sentry.addIntegration(lazyLoadedSentry.browserProfilingIntegration())
  Sentry.addIntegration(
    lazyLoadedSentry.replayIntegration({
      // NOTE: This will disable built-in masking.
      // Only use this if your site has no sensitive data, or if you've already set up other options for
      // masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
      maskAllText: false,
      blockAllMedia: false,
    })
  )
  Sentry.addIntegration(
    lazyLoadedSentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      colorScheme: 'system',
      showBranding: false,
      triggerLabel: '',
      useSentryUser: {
        name: 'name',
        email: 'email',
      },
    })
  )
})
